import React, { Component } from 'react';
import { SIZES, SWITCH_BUTTON_LAYOUT } from 'constants/components';
import CircleLoader from 'components/common/CircleLoader';
import {
  ButtonElement,
  TextElement,
  CheckIcon,
  CheckImageIcon,
  ButtonWrapper,
  AnswerImage
} from './SwitchButton.styled';

interface Sizes {
  [SIZES.SMALL]: string;
  [SIZES.MEDIUM]: string;
}

type SwitchButtonProps = {
  multiple: boolean;
  selected: boolean;
  hasNoRole?: boolean;
  type?: string;
  text?: string;
  textFor?: string;
  imageUrl?: string;
  onClick(e?: any): void;
  size: keyof Sizes;
  onKeyDown(e?: any): void;
  ariaDisabled?: boolean;
  altAnswerImage?: string;
  tabIndex: number;
  layout?: string;
  id?: string
};

type SwitchButtonState = {
  isImageLoaded: boolean;
}

export class SwitchButton extends Component<SwitchButtonProps, SwitchButtonState> {
  constructor(props: SwitchButtonProps) {
    super(props);
    this.state = { isImageLoaded: false };
  }
  static defaultProps = {
    size: SIZES.MEDIUM
  };

  handleImageLoaded = () => {
    this.setState({ isImageLoaded: true });
  };

  render() {
    const {
      onClick,
      onKeyDown,
      text,
      textFor,
      selected,
      multiple,
      imageUrl,
      hasNoRole,
      ariaDisabled = false,
      altAnswerImage,
      tabIndex,
      size,
      layout = SWITCH_BUTTON_LAYOUT.WITH_TEXT,
      id
    } = this.props;
    const { isImageLoaded } = this.state;
    let roleValue: any = multiple ? 'checkbox' : 'radio';
    roleValue = hasNoRole ? undefined : roleValue;
    return (
      <ButtonWrapper
        selected={selected}
        imageUrl={imageUrl}
        onClick={onClick}
        onKeyDown={onKeyDown}
        ariaDisabled={ariaDisabled}
        roleValue={roleValue}
        ariaChecked={selected}
        tabIndex={tabIndex}
        layout={layout}
      >
        {imageUrl && !isImageLoaded && <CircleLoader />}
        {imageUrl && (
          <AnswerImage
            alt={altAnswerImage}
            src={`${imageUrl}?height=260&amp;width=260&amp;scaleBySmallerSide=true`}
            onLoad={() => this.handleImageLoaded()}
          />
        )}
        <ButtonElement
          size={size}
          imageUrl={imageUrl}
          multiple={multiple}
          selected={selected}
          className="show-on-hover"
          layout={layout}
          id={id}
        >
          <CheckIcon size={9} name="ok" />
          {imageUrl && <CheckImageIcon size={60} name="check-mark" />}
        </ButtonElement>
        {text && (
          <TextElement appearance="p" selected={selected}>
            {textFor ? <label htmlFor={textFor}>{text}</label> : text}
          </TextElement>
        )}
      </ButtonWrapper>
    );
  }
}

export default SwitchButton;
